import { selectContactById } from '../../selectors'
import { doFetchContactForCustomField } from './doFetchContactForCustomField'

export const doFetchContactForPrimaryEmail = (
  email,
  isForNewTicket = false
) => async (dispatch, getState) => {
  const contactId = await dispatch(
    doFetchContactForCustomField(
      'contact_email',
      email,
      null,
      false,
      isForNewTicket
    )
  )

  return selectContactById(getState(), contactId)
}
